import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const EmptyContainer = styled.div `
  padding: ${theme.spacing['5xl']};
  padding-top: ${theme.spacing.md};
`;
